import { Scope } from '@talpor/react-context-manager';
import moment from 'moment';

import { setMood } from '../../utils/mood';
import { IStore } from '../index';

import { IChannelData, IMemberData } from './store';

export interface IDataActions extends Scope<IStore> {
  setData: (state: IStore) => (newData: any[]) => IStore;
}

const compare = (a: any, b: any) => {
  if (a.count < b.count) {
    return 1;
  }
  if (a.count > b.count) {
    return -1;
  }
  return 0;
};

export const dataActions: IDataActions = {
  setData: (state: IStore) => (newData: any[]) => {
    const timeData = new Array(10).fill(0);
    const timeDataArray = new Array(10).fill([]);
    let scoreSum = 0;
    let n = 0;
    const data: any[] = [];
    const channelData: IChannelData[] = [];
    const memberData: IMemberData[] = [];
    const moodData = { positive: 0, neutral: 0, negative: 0, total: 0 };
    newData.forEach((activity: any) => {
      const date = moment(activity.createdAt);
      const diff = Math.trunc(moment().diff(date) / 60000);
      if (diff < 10 && !data.map((d: any) => d.id).includes(activity.id)) {
        //////////////////// TIME DIGEST ////////////////////

        timeDataArray[diff] = [...timeDataArray[diff], activity];
        timeData[diff] = timeData[diff] + 1;
        scoreSum = scoreSum + activity.score;
        n = n + 1;

        data.push(activity);

        //////////////////// MOOD DIGEST ////////////////////

        const activityMood = setMood(activity.score);
        moodData[activityMood] = moodData[activityMood] + 1;

        //////////////////// CHANNELS DIGEST ////////////////////

        if (
          channelData.length > 0 &&
          channelData.find((channel: any) => channel.id === activity.channel)
        ) {
          const index = channelData.indexOf(
            channelData.filter(channel => channel.id === activity.channel)[0]
          );

          const channelDataMember = channelData[index].members.filter(
            (member: any) => member.id === activity.member
          )[0];
          let obj;
          const membersArray = [...channelData[index].members];
          if (channelDataMember) {
            const memberIndex = channelData[index].members.indexOf(channelDataMember);
            obj = {
              id: channelDataMember.id,
              count: channelDataMember.count + 1,
              score:
                (channelDataMember.score * channelDataMember.count + activity.score) /
                (channelDataMember.count + 1),
            };
            membersArray[memberIndex] = obj;
          } else {
            obj = { id: activity.member, count: 1, score: activity.score };
            membersArray.push(obj);
          }

          channelData[index] = {
            id: activity.channel,
            count: channelData[index].count + 1,
            score:
              (channelData[index].score * channelData[index].count + activity.score) /
              (channelData[index].count + 1),
            tokens: [...channelData[index].tokens, ...activity.tokens],
            members: membersArray,
            moodData: {
              ...channelData[index].moodData,
              [activityMood]: channelData[index].moodData[activityMood] + 1,
              total: channelData[index].moodData.total + 1,
            },
          };
        } else {
          const channelMoodData = { positive: 0, neutral: 0, negative: 0, total: 1 };
          const newChannel = {
            id: activity.channel,
            count: 1,
            score: activity.score,
            tokens: activity.tokens,
            members: [{ id: activity.member, count: 1, score: activity.score }],
            moodData: { ...channelMoodData, [activityMood]: 1 },
          };
          channelData.push(newChannel);
        }

        //////////////////// MEMBERS DIGEST ////////////////////

        if (
          memberData.length > 0 &&
          memberData.find((member: any) => member.id === activity.member)
        ) {
          const index = memberData.indexOf(
            memberData.filter(member => member.id === activity.member)[0]
          );

          const memberDataChannel = memberData[index].channels.filter(
            (channel: any) => channel.id === activity.channel
          )[0];
          let obj;
          const channelsArray = [...memberData[index].channels];
          if (memberDataChannel) {
            const channelIndex = memberData[index].channels.indexOf(memberDataChannel);
            obj = {
              id: memberDataChannel.id,
              count: memberDataChannel.count + 1,
              score:
                (memberDataChannel.score * memberDataChannel.count + activity.score) /
                (memberDataChannel.count + 1),
            };
            channelsArray[channelIndex] = obj;
          } else {
            obj = { id: activity.channel, count: 1, score: activity.score };
            channelsArray.push(obj);
          }

          memberData[index] = {
            id: activity.member,
            count: memberData[index].count + 1,
            score:
              (memberData[index].score * memberData[index].count + activity.score) /
              (memberData[index].count + 1),
            tokens: [...memberData[index].tokens, ...activity.tokens],
            channels: channelsArray,
            moodData: {
              ...memberData[index].moodData,
              [activityMood]: memberData[index].moodData[activityMood] + 1,
              total: memberData[index].moodData.total + 1,
            },
          };
        } else {
          const memberMoodData = { positive: 0, neutral: 0, negative: 0, total: 1 };
          const newMember = {
            id: activity.member,
            count: 1,
            score: activity.score,
            tokens: activity.tokens,
            channels: [{ id: activity.channel, count: 1, score: activity.score }],
            moodData: { ...memberMoodData, [activityMood]: 1 },
          };
          memberData.push(newMember);
        }
      }
    });

    const score = scoreSum / n;
    moodData.total = n;

    channelData.sort(compare);
    memberData.sort(compare);

    return {
      ...state,
      data: {
        ...state.data,
        channelData,
        data,
        score,
        timeData,
        timeDataArray,
        memberData,
        moodData,
      },
    };
  },
};
